// @flow
import _ from 'lodash';
import type {
  ProfileAddressType,
  ProfileType,
  PersonPhoneType,
  LanguageEnum,
} from '../types/profile/profile.flow';

export type PrimaryContactInfoType = {
  ...$Exact<ProfileType>,
  personId: string,
  coverageState?: string,
  homeAddress?: ProfileAddressType,
  mailingAddress?: ProfileAddressType,
  primaryPhoneNumber?: PersonPhoneType,
  secondaryPhoneNumber?: PersonPhoneType,
  mobileNotificationPhoneNumber?: String,
  spokenLanguageType?: LanguageEnum,
  writtenLanguageType?: LanguageEnum,
  isPrimaryApplying: boolean,
  birthDate: string,
  sex: 'FEMALE' | 'MALE',
};

const sortPhones = (phones: Array<PersonPhoneType>) => {
  if (!_.isArray(phones)) return [];
  const order = {
    MOBILE: 1,
    HOME: 2,
    WORK: 3,
  };
  const sortedPhone = [...phones];
  sortedPhone.sort((a, b) => order[a.type] - order[b.type]);
  return sortedPhone;
};

// TODO: type out Profile and add compatible data fields as getPrimaryContactInfo
export const getProfileContactInfo = (
  profile: ProfileType | {},
  productApp: Object,
): PrimaryContactInfoType => {
  const { id, addresses = [], phones, languageSpoken, languageWritten } = profile;

  const homeAddress = _.find(addresses, { addressType: 'HOME' });
  const mailingAddress = _.find(addresses, { addressType: 'MAILING' });
  const transientAddress = _.find(addresses, { addressType: 'TRANSIENT' });
  const coverageState = _.get(homeAddress, 'state');
  const sortedPhone = sortPhones(phones);
  const primaryPhoneNumber = sortedPhone[0];
  const secondaryPhoneNumber = sortedPhone[1];

  // lookup applicant in productApp for coverage type
  const appApplicants = _.get(productApp, 'applicants', []);
  const primary = _.find(appApplicants, { personId: id });
  const isPrimaryApplying = primary ? primary.type === 'coverage' : true;

  return {
    ...profile,
    birthDate: profile.dob,
    personId: id,
    coverageState,
    homeAddress,
    mailingAddress,
    transientAddress,
    primaryPhoneNumber,
    secondaryPhoneNumber,
    spokenLanguageType: languageSpoken,
    writtenLanguageType: languageWritten,
    isPrimaryApplying,
  };
};
